'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { usageTracker } from 'AdsUI/lib/usageTracker';

function TrackedRedirect(_ref) {
  let {
    name
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["name"]);

  useEffect(() => {
    usageTracker.track('pageView', {
      screen: name
    });

    if (name !== 'campaigns-list') {
      window.HS_SKIP_CUSTOM_PERF = true;
    }
  }, [name]);
  return /*#__PURE__*/_jsx(Redirect, Object.assign({}, rest));
}

export default TrackedRedirect;